import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";
// Librairie
import Axios from "axios";
import {useHistory} from "react-router-dom";
import Linkify from "react-linkify";
// Assets
import "./styles.scss";
import Pap from "../../../../assets/img/pap.png";
import Accept from "../../../../assets/icons/accept.svg";
import Refuse from "../../../../assets/icons/refuse.svg";
import Document from "../../../../assets/img/document.png";
import {getUploadUrl} from "../../../../utils/baseUrl";
// Utils
import {formatSQLDateLong, formatSQLDateShort} from "../../../../utils/formatSQLDate";
import {handleDownload} from "../_utils/handleDownloadDocument";

const Messages = ({
                      messages,
                      cas,
                      setShowAcceptPapModal,
                      setShowAcceptDevisModal,
                      setShowRejectPapModal,
                      setShowRejectDevisModal,
                      showAcceptPapModal,
                      showAcceptDevisModal,
                      showRejectPapModal,
                      showRejectDevisModal,
                      setShowPap,
                      showPap,
                      documents
                  }) => {
    //
    const history = useHistory();
    useEffect(() => {
        if (cas) {
            // La propriété state d'un cas détermine son le statut du Plan d'Aide Personnalisé (PAP)
            // state === 100 : refusé
            // state === 5 : accepté
            // state === 4 : en attente
            if (cas.state === 100 || cas.state < 4) {
                // Si le PAP a été accepter ou refuser, on fait disparaître le message dédia au pap
                setShowPap(false);
            } else {
                // Sinon on affiche le pap
                setShowPap(true);
            }
        }
    }, []);

    // Utilisé pour focus l"écran sur
    const lastListElement = useRef(null);

    useEffect(() => {
        // Focus le dernier message lorsqu'un nouveau apparaît
        lastListElement.current.scrollIntoView(lastListElement);
    }, [messages]);

    const toggleAcceptPapModal = () => {
        setShowAcceptPapModal(!showAcceptPapModal);
    };
    const toggleRejectPapModal = () => {
        setShowRejectPapModal(!showRejectPapModal);
    };
    const toggleAcceptDevisModal = (id) => {
        setShowAcceptDevisModal(!showAcceptDevisModal, id);
    };
    const toggleRejectDevisModal = (id) => {
        setShowRejectDevisModal(!showRejectDevisModal, id);
    };

    const handleDownloadDevis = (id) => {
        // Téléchargement du devis via une requête Axios
        Axios({
            method: "get",
            // On passe l'id du devis dans la reqête
            url: `${getUploadUrl()}/devis/${id}.pdf`,
            responseType: "arraybuffer"
        })
            .then((response) => {
                // on créer un élément à la volée
                var link = document.createElement("a");

                if (window["ReactNativeWebView"]) {
                    // Dans le cas de la webview React-Native, on assigne l'url de la réponse à la propriété href
                    link.href = response.config.url;
                } else {
                    // Sinon on créé une chaine contenant l'URL représentant l'objet passé en paramètre
                    // https://developer.mozilla.org/fr/docs/Web/API/URL/createObjectURL
                    link.href = window.URL.createObjectURL(
                        new Blob([response.data], {type: "application/octet-stream"})
                    );
                }
                // Download du fichier
                link.download = `${id}.pdf`;
                // On ajoute le fichier au DOM
                document.body.appendChild(link);
                // On clique pour lancer le téléchargement
                link.click();
                // On révoque l'objet URL pur effacer la référence à cet objet stocké par le navigateur
                // https://developer.mozilla.org/fr/docs/Web/API/URL/revokeObjectURL
                setTimeout(function () {
                    window.URL.revokeObjectURL(link);
                }, 200);
            });
    };

    return (
        <>
            <div>
                {messages.length !== 0 &&
                    messages.map((mess, index) => {
                        return (
                            <div key={index}>
                                <div className={`${mess.idCareManager == 0 ? "bulle-droite" : "bulle-gauche"} fade`}>
                                    {mess.idDocument == 0 &&
                                        <div
                                            className={`bulleMessage ${mess.idCareManager == 0 ? "bulleUserChat" : "bulleCareManager"} fade`}>
                                            <Linkify>
                                                {mess.content}
                                            </Linkify>
                                        </div>
                                    }
                                    {
                                        // TYPE 0 = DOCUMENT
                                        // TYPE 1 = DEVIS
                                        mess.idDocument != 0 &&
                                        documents.map((doc) => {
                                            if (doc.id == mess.idDocument && doc.type == 0) {
                                                // On affiche le document s'il y en a dans la liste des messages
                                                return (
                                                    <div key={doc.id} className="bulle-document">
                                                        <div>
                                                            <div className="contenu-doc"
                                                                 onClick={() => handleDownload(doc.name, doc.nameOrig)}>
                                                                <img src={Document} alt="document"/>
                                                                <div>
                                                                    <h1>{doc.nameOrig}</h1>
                                                                </div>
                                                            </div>
                                                            <div className="proposition">
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            } else if (doc.id === mess.idDocument && doc.type == 1) {
                                                // On affiche les devis qui sont présent dans les messages
                                                return (
                                                    <div key={doc.id} className="bulle-document">
                                                        <div>
                                                            <div className="contenu-doc">
                                                                <img src={Pap} alt="Devis"/>
                                                                <div>
                                                                    <h1>Devis de {doc.namePrestataire}</h1>
                                                                    <h2>Ajouté le {doc.datePost}</h2>
                                                                </div>
                                                            </div>
                                                            {doc.state != 1 && doc.state != 2 &&
                                                                <div className="proposition">
                                                                    <button className="acceptDevis"
                                                                            onClick={() => toggleAcceptDevisModal(doc.id)}>
                                                                        <img src={Accept} alt="Accepter"/></button>
                                                                    <button className="refuseDevis"
                                                                            onClick={() => toggleRejectDevisModal(doc.id)}>
                                                                        <img src={Refuse} alt="Refuser"/></button>
                                                                    <button className="consulter"
                                                                            onClick={() => handleDownloadDevis(doc.id)}>Consulter
                                                                    </button>
                                                                </div>
                                                            }
                                                            {doc.state == 1 &&
                                                                <div className="proposition-stated">
                                                                    <h2>Accepté</h2>
                                                                    <button className="consulter-variante"
                                                                            onClick={() => handleDownloadDevis(doc.id)}>Consulter
                                                                    </button>
                                                                </div>
                                                            }
                                                            {doc.state == 2 &&
                                                                <div className="proposition-stated">
                                                                    <h2>Refusé</h2>
                                                                    <button className="consulter-variante"
                                                                            onClick={() => handleDownloadDevis(doc.id)}>Consulter
                                                                    </button>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        })

                                    }
                                    <span className="date-envoi-chat">{formatSQLDateLong(mess.date)}</span>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
            {cas.state < 5 && cas.state != 100 && showPap &&
                // On affiche le PAP s'il en existe un ou s'il n'a pas été refusé ou accepté
                <div className="bulle-document">
                    <div>
                        <div className="contenu-doc" onClick={() => history.push(`/pap/${cas.id}`)}>
                            <img src={Pap} onClick={() => history.push(`/pap/${cas.id}`)}/>
                            <div onClick={() => history.push(`/pap/${cas.id}`)}>
                                <h1>Plan&nbsp;d&apos;aide&nbsp;personnalisé</h1>
                                <h2>Ajouté le {formatSQLDateShort(cas.dateOpen)}</h2>
                                {cas.state == 5 &&
                                    <h2>Accepté</h2>
                                }
                            </div>
                        </div>
                        <div className="proposition">
                            {cas.state == 4 &&
                                <>
                                    <button onClick={toggleAcceptPapModal} className="accept"><img src={Accept}
                                                                                                   alt="accepter"/> J&apos;accepte
                                    </button>
                                    <button onClick={toggleRejectPapModal} className="refuse"><img src={Refuse}
                                                                                                   alt="refuser"/> Je&nbsp;refuse
                                    </button>
                                    <button onClick={() => history.push(`/pap/${cas.id}`)}
                                            className="consulter">Consulter
                                    </button>
                                </>
                            }
                            {
                                cas.state == 5 &&
                                <button onClick={() => history.push(`/pap/${cas.id}`)}
                                        className="consulter">Consulter</button>
                            }
                        </div>
                    </div>
                </div>
            }
            <div ref={lastListElement}/>
            <div className="spacer-blur"></div>
        </>
    );
};

Messages.propTypes = {
    messages: PropTypes.array,
    cas: PropTypes.object,
    acceptPap: PropTypes.func,
    rejectPap: PropTypes.func,
    setShowAcceptPapModal: PropTypes.func,
    setShowAcceptDevisModal: PropTypes.func,
    setShowRejectPapModal: PropTypes.func,
    setShowRejectDevisModal: PropTypes.func,
    showAcceptPapModal: PropTypes.bool,
    showAcceptDevisModal: PropTypes.bool,
    showRejectPapModal: PropTypes.bool,
    showRejectDevisModal: PropTypes.bool,
    showPap: PropTypes.bool,
    setShowPap: PropTypes.func,
    documents: PropTypes.array,
};

export default Messages;
